import type { PermissionSelector } from "hooks/usePermission";

// List is always available to show at least "own" content. Items filtered on backend
export const canListEvents: PermissionSelector = () => true;

export const canManageEvents: PermissionSelector = (x) => x.events.canManage;
